import api from '../../services/api';
import { parseLogin } from './loginParser';

export const authenticateUser = async (username, password) => {
    const response = await api.post('/login', parseLogin(username, password));
    return response.data;
};
